import { getNumberFeatureFlagValue, subscribeToFeatureFlags } from './launchDarklyClient'

import { NumberFeatureFlag } from './featureFlags'
import { useSyncExternalStore } from 'react'

/**
 * Reads a numeric feature flag from LaunchDarkly, e.g. a tunable limit.
 *
 * Semantics callers may rely on: an unknown, unreachable, not-yet-loaded or
 * non-numeric flag evaluates to `fallback`, so the value compiled into the call
 * site is always the existing/safe behaviour. Values update live.
 *
 * In tests, mock this module rather than the vendor package:
 *
 * ```ts
 * vi.mock('utils/featureFlags/useNumberFeatureFlag', () => ({ useNumberFeatureFlag: vi.fn() }))
 * ```
 */
export const useNumberFeatureFlag = (flag: NumberFeatureFlag, fallback: number): number =>
  useSyncExternalStore(
    subscribeToFeatureFlags,
    () => getNumberFeatureFlagValue(flag, fallback),
    () => fallback
  )
